import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AddEditQualificationPage from './pages/AddEditQualificationPage';
import QualificationPage from './pages/QualificationPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import UsersPage from './pages/UsersPage';
import Footer from './components/Footer';

function App() {
  return (
    <Box sx={{ width: '100vw', height: '100vh', minHeight: 0, display: 'flex', flexDirection: 'column', position: 'relative' }}>
      <Box sx={{ flex: 1, overflow: 'auto', pb: '32px' }}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/change-password" element={<ChangePasswordPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/" element={<DashboardPage />} />
          <Route path="/add" element={<AddEditQualificationPage />} />
          <Route path="/edit/:id" element={<AddEditQualificationPage />} />
          <Route path="/qualification/:id" element={<QualificationPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Box>
      <Footer />
    </Box>
  );
}

export default App;
